import React from 'react';
import Signup from '../components/auth/Signup';

const SignupPage = () => {
  return <Signup />;
};

export default SignupPage;